{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} бесед выбрано",
    "NONE": "Ничего",
    "CLEAR_SELECTION": "Сбросить",
    "ASSIGN_AGENT_CONFIRMATION_LABEL": "Вы уверены, что вы хотите назначить разговор {n} для {agentName}? | Вы уверены, что хотите назначить {n} разговоры {agentName}?",
    "UNASSIGN_AGENT_CONFIRMATION_LABEL": "Вы уверены, что хотите отменить назначение разговора {n}? | Вы уверены, что хотите отменить назначение разговоров {n}?",
    "YES": "Да",
    "CANCEL": "Отменить",
    "SEARCH_INPUT_PLACEHOLDER": "Поиск",
    "ASSIGN_AGENT_TOOLTIP": "Назначить агента",
    "ASSIGN_TEAM_TOOLTIP": "Назначить команду",
    "ASSIGN_SUCCESFUL": "Беседы успешно назначены.",
    "ASSIGN_FAILED": "Не удалось назначить диалоги, попробуйте еще раз.",
    "RESOLVE_SUCCESFUL": "Беседы успешно завершены.",
    "RESOLVE_FAILED": "Не удалось завершить диалоги, попробуйте еще раз.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Выбраны только беседы, видимые на этой странице.",
    "UPDATE": {
      "CHANGE_STATUS": "Изменить статус",
      "SNOOZE_UNTIL": "Отложено",
      "UPDATE_SUCCESFUL": "Статус беседы успешно обновлен.",
      "UPDATE_FAILED": "Не удалось обновить диалоги, попробуйте еще раз."
    },
    "RESOLVE": {
      "ALL_MISSING_ATTRIBUTES": "Невозможно завершить диалоги: отсутствуют обязательные атрибуты",
      "PARTIAL_SUCCESS": "Некоторые диалоги были пропущены: перед завершением необходимо заполнить обязательные атрибуты"
    },
    "LABELS": {
      "ASSIGN_LABELS": "Назначить метки",
      "REMOVE_LABELS": "Remove labels",
      "ASSIGN_SELECTED_LABELS": "Назначить выбранные метки",
      "REMOVE_SELECTED_LABELS": "Remove selected labels",
      "ASSIGN_SUCCESFUL": "Метки успешно назначены.",
      "ASSIGN_FAILED": "Не удалось назначить метки, пожалуйста, попробуйте снова.",
      "REMOVE_SUCCESFUL": "Labels removed successfully.",
      "REMOVE_FAILED": "Failed to remove labels. Please try again."
    },
    "TEAMS": {
      "NONE": "Ничего",
      "ASSIGN_TEAM_CONFIRMATION_LABEL": "Вы уверены, что вы хотите назначить разговор {n} для {teamName}? | Вы уверены, что хотите назначить {n} разговоры {teamName}?",
      "UNASSIGN_TEAM_CONFIRMATION_LABEL": "Вы уверены, что хотите отменить назначение разговора {n}? | Вы уверены, что хотите отменить назначение разговоров {n}?",
      "ASSIGN_SUCCESFUL": "Команды успешно назначены.",
      "ASSIGN_FAILED": "Не удалось назначить команду, попробуйте еще раз."
    }
  }
}
